const JOURS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
const MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

export const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const todayIso = () => toIso(new Date());

export const fmtLongDate = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  return `${JOURS[dt.getDay()]} ${d} ${MOIS[m - 1]} ${y}`;
};

export const DEMARRAGE = 'Démarrage de la journée : prise de connaissance des priorités et organisation des tâches.';

export const RECAP_FIELDS = [
  { key: 'activites', label: 'Activités réalisées', required: true, rows: 4, placeholder: 'Décrivez ici votre journée de travail...' },
  { key: 'rdv', label: 'Rendez-vous et échanges', rows: 2, placeholder: 'Indiquez les rendez-vous, appels, emails ou échanges importants...' },
  { key: 'actions', label: 'Actions effectuées', rows: 2, placeholder: 'Listez les actions concrètes que vous avez menées...' },
  { key: 'resultats', label: 'Résultats obtenus', rows: 2, placeholder: "Quels sont les résultats ou avancées obtenus aujourd'hui ?" },
  { key: 'difficultes', label: 'Difficultés / points à suivre', rows: 2, placeholder: 'Précisez les éventuelles difficultés rencontrées ou points à suivre...' },
  { key: 'priorites', label: 'Priorités pour demain', rows: 2, placeholder: 'Quelles sont vos priorités pour la journée de demain ?' },
];

export const emptyRecap = () => ({ activites: `${DEMARRAGE}\n`, rdv: '', actions: '', resultats: '', difficultes: '', priorites: '' });
